/**
 * Timestamp helpers shared by the message threading hooks.
 */

/**
 * Parse a raw timestamp value to epoch millis for sorting.
 *
 * Callers pass an explicit ``whenMissing`` sentinel for null / empty / unparseable
 * values so that "unknown" always sorts *last* regardless of sort direction:
 * use ``Number.NEGATIVE_INFINITY`` for a newest-first (descending) sort and
 * ``Number.POSITIVE_INFINITY`` for an oldest-first (ascending) sort.
 */
export function timestampMillis(value: unknown, whenMissing: number): number {
  if (value == null || value === '') return whenMissing;
  const parsed = new Date(String(value)).getTime();
  return Number.isNaN(parsed) ? whenMissing : parsed;
}
